import React from "react";
import "./Button.scss"
const Button = ({ isPrimary = true, buttonText, onClick, fontSize, fontWeight, width }) => {
    return (
        <div
            className={isPrimary ? "Witearn-button-primary" : "Witearn-button-secondary"}
            onClick={onClick}
            style={{ fontSize, fontWeight, width }}>
            {buttonText}
        </div >
    )
}
export default Button